const { getProjectRoles } = require('../../../services/projectService');

const FilterProjectRoles = async (id) => {
  try {
    const roles = await getProjectRoles(id);
    const filteredRoles = roles.data.data;
    return filteredRoles;
  } catch (error) {
    console.error(error);
    throw new Error('Failed to fetch project roles.');
  }
};

export default FilterProjectRoles;
